/**
 * 控制用户登录按钮 
 */
import React from 'react';
import { 
  Bootstrap 
} from '../components';

export default class LoginControl extends React.Component {
  constructor(props) {
    super(props);
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
    this.state = {isLoggedIn: false};
  }

  handleLoginClick(e) {
    e.preventDefault();
    this.setState({isLoggedIn: true});
  }

  handleLogoutClick(e) {
    e.preventDefault();
    this.setState({isLoggedIn: false});
  }

  render() {
    let button = null;
    if (this.state.isLoggedIn) {
      button = <LogoutButton onClick={this.handleLogoutClick} />
    } else {
      button = <LoginButton onClick={this.handleLoginClick} />
    }

    return button
  }
}

function LogoutButton(props) {
  return (<a href="" onClick={props.onClick}>{Bootstrap.Glyphicons("log-out")} 退出</a>)
}

function LoginButton(props) {
  return (<a href="" onClick={props.onClick}>{Bootstrap.Glyphicons("user")} 登录</a>)
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/LoginControl.js